module.exports = __webpack_public_path__ + "static/arcadium-sm-c3036c3b9a9aa4f945d2105265c67181.jpg";